import React, { useState } from "react";
import Quotation from "./Quotation";
import KitchenEstimate from "./KitchenEstimate";
import WardrobeEstimate from "./WardrobeEstimate";

const SeperatePricingContainer = () => {
  const [activeForm, setActiveForm] = useState(null);

  const closeForm = () => {
    setActiveForm(null);
  };

  return (
    <div className="bg-white py-6">
      <h1 className="text-2xl font-semibold text-center mb-8">
        Choose Your Interior Plan
      </h1>
      <div className="container mx-auto grid grid-cols-1 md:grid-cols-3 gap-4 px-6">
        {/* Kitchen Card */}
        <div className="bg-white rounded-lg p-6 text-center relative shadow-custom">
          <h3 className="text-lg font-semibold mb-2">Kitchen</h3>
          
          <p className="text-sm text-gray-500 mb-4">
            Get an approximate costing for your kitchen
          </p>
          <div className="flex items-center justify-center p-2">
            <img
              src="/images/kitchen-4.png"
              alt="Kitchen best interior designers in hyderabad"
              className="w-auto h-16 object-contain" // Keep image size with aspect ratio maintained
            />
          </div>
          <button
            onClick={() => setActiveForm("kitchen")}
            className="mt-4 bg-[#e9a200] text-white font-bold py-2 px-4 rounded-xl"
          >
            Calculate &gt;
          </button>
        </div>
         {/* Full Home Interior Card */}
         <div className="bg-white rounded-lg p-6 text-center relative shadow-custom">
         <h3 className="text-lg font-semibold mb-2">Full Home</h3>
         <p className="text-sm text-gray-500 mb-4">
           Know the estimate price for your full home
         </p>
         <div className="flex items-center justify-center p-2">
           <img
             src="/images/living-room.jpeg"
             alt="Kitchen best interior designers in hyderabad"
             className="w-auto h-16 object-contain" // Keep image size with aspect ratio maintained
           />
         </div>
         <button
           onClick={() => setActiveForm("fullHome")}
           className="mt-4 bg-[#e9a200] text-white font-bold py-2 px-4 rounded-xl"
         >
           Calculate &gt;
         </button>
       </div>

        {/* Wardrobe Card */}
        <div className="bg-white rounded-lg p-6 text-center relative shadow-custom">
          <h3 className="text-lg font-semibold mb-2">Wardrobe</h3>
          <p className="text-sm text-gray-500 mb-4">
            Our estimate for your dream wardrobe
          </p>
          <div className="flex items-center justify-center p-2">
            <img
              src="/images/cupboard-2.png"
              alt="Kitchen best interior designers in hyderabad"
              className="w-auto h-16 object-contain" // Keep image size with aspect ratio maintained
            />
          </div>
          <button
            onClick={() => setActiveForm("wardrobe")}
            className="mt-4 bg-[#e9a200] text-white font-bold py-2 px-4 rounded-xl"
          >
            Calculate &gt;
          </button>
        </div>

       
      </div>

      {/* Modal for Forms */}
      {activeForm && (
        <div className="fixed inset-0 z-50 flex justify-center items-center bg-black bg-opacity-50 backdrop-blur-sm">
          <div className="bg-white p-6 rounded-xl shadow-xl w-[90%] max-w-md sm:w-96">
            <div className="flex justify-between items-center mb-4">
              <h2 className="text-lg font-semibold">
                {activeForm === "kitchen"
                  ? "Kitchen Estimate"
                  : activeForm === "wardrobe"
                  ? "Wardrobe Estimate"
                  : "Full Home Interior Estimate"}
              </h2>
              <button
                className="text-gray-500 hover:text-gray-800"
                onClick={closeForm}
              >
                ✖
              </button>
            </div>
            {activeForm === "kitchen" && (
              <KitchenEstimate onReset={closeForm} />
            )}
            {activeForm === "wardrobe" && (
              <WardrobeEstimate onReset={closeForm} />
            )}
            {activeForm === "fullHome" && <Quotation onReset={closeForm} />}
          </div>
        </div>
      )}
    </div>
  );
};

export default SeperatePricingContainer;
